import { render, staticRenderFns } from "./TelecallerLeaderboard.vue?vue&type=template&id=6ce86dbc&scoped=true&"
import script from "./TelecallerLeaderboard.vue?vue&type=script&lang=js&"
export * from "./TelecallerLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./TelecallerLeaderboard.vue?vue&type=style&index=0&id=6ce86dbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce86dbc",
  null
  
)

export default component.exports